import { Component, OnInit } from '@angular/core';
import {faKey, faCheckCircle} from '@fortawesome/free-solid-svg-icons';
import {CentralService} from '../servicios/central.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mdfclave',
  templateUrl: './mdfclave.component.html',
  styleUrls: ['./mdfclave.component.css']
})
export class MdfclaveComponent implements OnInit {
  icoClv = faKey;
  icoVal  = faCheckCircle;
  nomusu: string;
  nuevaclv1: string;
  nuevaclv2: string;
  resul: boolean;
  xErro: string;


  constructor(private srvCentral: CentralService,  private router: Router) { }

  ngOnInit(): void {
    this.nomusu = this.srvCentral.datosIden.UsuNom;
    this.nuevaclv1 = '';
    this.nuevaclv2 = '';
  }

  reset(): void {
    this.xErro = '';
    this.resul = false;
  }

  validar(): void {
    if (this.nuevaclv1 !== this.nuevaclv2) {
        this.xErro = 'La contraseña y su confirmación no son iguales';
        return;
    }
    if (this.nuevaclv1.length < 6 ) {
        this.xErro = 'La contraseña debe tener al menos seis caracteres';
        return;
    }

    const num = this.miraNum(this.nuevaclv1);
    const ltr = this.miraLet(this.nuevaclv1);
    if (num === 0) {
      this.xErro = 'La contraseña debe tener al menos un número';
      return;
    }
    if (ltr === 0) {
      this.xErro = 'La contraseña debe tener al menos una letra';
      return;
    }

    this.resul = true;
    this.srvCentral.cambiaClave(this.nuevaclv1)
        .subscribe(result => {
          if ( result[0].Swresul === true) {
            this.resul = false;
            this.srvCentral.datosIden.UsuClv = this.nuevaclv1;
            this.router.navigate(['/portada']);
          } else {
            this.resul = false;
            this.xErro = result[0].Txresul;
          }
    });
  }

  miraNum(tx): number {
    const numeros = '0123456789';
    for ( let i = 0; i < tx.length; i++) {
      if (numeros.indexOf(tx.charAt(i), 0) !== -1) {
         return 1;
      }
    }
    return 0;

  }
  miraLet(tx): number {
    const letras = 'abcdefghyjklmnñopqrstuvwxyz';
    tx = tx.toLowerCase();
    for ( let i = 0; i < tx.length; i++) {
       if (letras.indexOf(tx.charAt(i), 0) !== -1 ) {
          return 1;
       }
    }
    return 0;
  }

}
